import { KENO_NUMBER_STATUS, KenoNumber } from '../base/number'
import { PLINKO_ATLAS_FRAMES, PLINKO_TEXTURE_KEYS } from './constants'
import { KenoAnimationScene } from '@Animation/scenes/keno-animation'
import { STANDARD_LARGE_NUMBER_RATIO } from '@Animation/constants'
import { ANIMATION_IDENTIFIERS } from '@Animation/types'

export class PlinkoNumber extends KenoNumber {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    number: number,
    isPlayerSelected: boolean,
  ) {
    super(scene, x, y, number, isPlayerSelected, ANIMATION_IDENTIFIERS.PLINKO)
    this.kenoScene = scene as KenoAnimationScene
  }

  getGlowAtlasFrame() {
    return PLINKO_ATLAS_FRAMES.NUMBER_GLOW
  }

  getGlowAtlas() {
    return PLINKO_TEXTURE_KEYS.ATLAS
  }

  createStatusTextureMap(): { [key in KENO_NUMBER_STATUS]: string } {
    return {
      [KENO_NUMBER_STATUS.DEFAULT]: PLINKO_TEXTURE_KEYS.NUMBER_DEFAULT,
      [KENO_NUMBER_STATUS.SELECTED_PLAYER]: PLINKO_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_SYSTEM]: PLINKO_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_HIT]: PLINKO_TEXTURE_KEYS.NUMBER_HIT,
    }
  }

  async transitionToSystemSelected(): Promise<void> {
    super.transitionToSystemSelected()

    await this.popNumberTexture(
      PLINKO_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION,
      STANDARD_LARGE_NUMBER_RATIO,
      1,
    )
  }

  async transitionToSelectedHit() {
    await this.popNumberTexture(
      PLINKO_TEXTURE_KEYS.NUMBER_HIT_TRANSITION,
      STANDARD_LARGE_NUMBER_RATIO,
      1,
    )
    super.transitionToSelectedHit()
  }
}
